/**
 * 查看培训记录
 * @author xyguo
 * @date 2021-3-16
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizModal, WizComponent, WizForm, WizCheckbox, WizSelect, WizInput, WizRow, WizCol, WizSpin, WizButton } = component_tool;
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { $$, checkStrLength } = utils_tool;
import '../../../../styles/containers/train/path/requirement/style.less'
class DpStateSet extends WizContainer {

  componentName = 'DpStateSet';

  constructor(props) {
    super(props)
    let { record, reportType } = props
    this.state = {
      record,
      dataDetail: {},
      reportType,
      trainDpStatus: record.trainDpStatus,
      remark: record.remark,
      timestamp: new Date().getTime()
    }
    this.initialValue = record
  }

  _componentDidMount() {
    if (this.state.record && this.state.record.id) {
      this._getInfo();
    }
  }

  _getInfo() {
    let { record } = this.state
    this.doAction({
      path: 'requirementOrgPerson/getInfo',
      payload: {
        key: 'requirementOrgPerson@getInfo'+record.id,
        apiParams: { id: record['id'], reportType: this.state.reportType }
      },
    })
  }

  _onSave = () => {
    let { trainDpStatus, remark, record } = this.state
    if (trainDpStatus === undefined || trainDpStatus === null || trainDpStatus ===2) {
      wizNotice.warn('DP状态不可为空');
      return;
    }
    if (!remark) {
      wizNotice.warn('备注不可为空');
      return;
    }
    const personInfo = <font color='red'>{record.fullName}（{record.userName}）</font>
    const trainDpStatusStr = <font color='red'>{trainDpStatus===0?"未通过":"已通过"}</font>
    const content = <div>
      您正在将学员{personInfo}， {record.orgName} - {record.positionName}的DP状态设置为“{trainDpStatusStr}”，此操作不可逆，确认后DP状态将推送给DP，是否确认？
    </div>
    WizModal.confirm({
      title: '信息确认',
      //icon:false,
      content: content,
      width: 500,
      onOk: () => {
        this.doAction({
          path: 'requirementOrgPerson/dpStateSet',
          payload: {
            key: 'requirementOrgPerson@dpStateSet',
            apiParams: {
              id: record.id,
              trainDpStatus,
              remark
            }
          }
        })
      },
      onCancel() {
      }
    });
  }

  propsAndStateOnChange = {
    getInfo: this._getInfoOver.bind(this),
    dpStateSet: this._dpStateSetOver.bind(this),
  };

  _getInfoOver(nextProps, nextState) {
    let { getInfo } = nextProps
    if (getInfo['success']) {
      nextState['dataDetail'] = getInfo.data
      return true;
    } else {
      wizNotice.error(getInfo['msg'] || '获取数据失败，请稍后再试')
    }
    return false;
  }

  _dpStateSetOver(nextProps, nextState) {
    if (nextProps.dpStateSet.code === 1) {
      wizNotice.success('保存成功');
      nextProps.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.dpStateSet.msg);
    }
  }

  _rowViewHead(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={10}>{title}</WizCol>
        <WizCol offset={2} span={10}>{value}</WizCol>
      </WizRow>
    )
  }

  _rowViewBody(titleA, valueA, titleB, valueB) {
    let showA = titleA && valueA ? ":" : ""
    let showB = titleB && valueB ? ":" : ""
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={5}> {titleA}{showA}</WizCol>
        <WizCol span={3}>{valueA}</WizCol>
        <WizCol offset={1} span={3}>{titleB}{showB}</WizCol>
        <WizCol offset={0} span={10}>{valueB}</WizCol>
      </WizRow>
    )
  }

  _rowViewTail(title, value) {
    return (
      <WizRow className="look-row">
        <WizCol offset={2} span={3}>{title}:</WizCol>
        <WizCol span={19}>{value}</WizCol>
      </WizRow>
    )
  }

  _rowTitleView(title) {
    return (
      <WizRow className="look-row">
        <WizCol span={20} offset={1} ><strong>{title}</strong></WizCol>
      </WizRow>
    )
  }

  _getContentName(type) {
    let contentNameObj =
    {
      0: "路径名称",
      1: "认证名称",
      2: "课程名称",
      // 3:"人员测评",
      // 4:"标杆店实践",
      // 5:"个人简历",
      // 6:"性格测试",
      // 7:"面试结果",
      // 8:"电工证",
      // 9:"岗位认证",
      10: "考试名称",
      11: "完成情况"
    }
    return contentNameObj[type]
  }

  _personInfo(dataDetail) {
    return <div className="menu-item item-title">
      {this._rowTitleView('学员基本信息')}
      {this._rowViewHead('姓名：' + dataDetail.fullName, '账号：' + dataDetail.userName)}
      {this._rowViewHead('岗位：' + dataDetail.positionName, '状态：' + dataDetail.jobStateStr)}
    </div>;
  }

  _trainInfo(dataDetail) {
    let returnInfo = []
    if (dataDetail.allShowContentMap &&  Object.keys(dataDetail.allShowContentMap).length) {
      Object.keys(dataDetail.allShowContentMap).forEach(key => {
        const value = dataDetail.allShowContentMap[key];
        if (value != null && value != undefined) {
          let { showTitle, contentState, entity } = value
          let entityName = entity && entity.entityName
          if(entity && entity.onlineCourseFinishRate){
            entityName = entity.onlineCourseFinishRate
          }
          let entityTypeName = this._getContentName(key);
          let rowViewBody = this._rowViewBody(showTitle, contentState, entityTypeName, entityName)
          returnInfo.push(rowViewBody);
        }
      })
    }else{
      let rowViewBody = this._rowViewBody("本岗位暂无考核要求",undefined,undefined,undefined)
      returnInfo.push(rowViewBody)
    }
    return <div className="menu-item">
      {this._rowTitleView('学员培训情况')}
      {returnInfo}
    </div>;
  }



  _dpInfo(dataDetail) {
    if (this.state.reportType) {
      return <div className="menu-item">
        {this._rowTitleView('DP状态')}
        <WizRow className="look-row" >
          <WizCol offset={2} span={3} style={{ paddingTop: '5px' }}><font style={{color:'red',verticalAlign:'middle'}}>*</font>DP状态:</WizCol>
          <WizCol span={19}>
            <WizSelect placeholder="请选择DP状态" onChange={(e) => { this.setState({ trainDpStatus: e }) }} style={{ width: '30%', "minWidth": '72px', "paddingRight": '7px' }}>
              <Option value={0}> 未通过 </Option>
              <Option value={1}> 已通过 </Option>
            </WizSelect>
          </WizCol>
        </WizRow>
        <WizRow className="look-row">
          <WizCol offset={2} >
          <font color='red'>
          注意：您对该学员“DP状态”结果的调整将会记录在系统中，作为后续查看培训情况的参考，请严谨操作。
          </font>
          </WizCol>
        </WizRow>
        <WizRow className="look-row" >
          <WizCol offset={2} span={3} ><font style={{color:'red', verticalAlign: 'middle' }}>*</font>备注:</WizCol>
          <WizCol span={15}>
            <WizInput.TextArea rows={4} maxLength={100} placeholder={'请输入备注'}
              defaultValue={this.initialValue.remark}
              onChange={(e) => {
                this.setState({ remark: e.target.value })
              }}
            />
          </WizCol>
        </WizRow>
        <WizRow className='audit-submit-button-row'>
          <WizCol>
            <WizButton title='取消' onClick={() => { this.setState({ timestamp: new Date().getTime() }); this.props.changeModal(false) }}>取消</WizButton>
            <WizButton title='确认' type='primary' onClick={() => this._onSave()}>确认</WizButton>
          </WizCol>
        </WizRow>
      </div>;
    }
  }


  render() {
    const { requirementOrgPersonLoading } = this.props;
    let { record, timestamp, dataDetail } = this.state
    return <WizSpin tip={'加载中'} spinning={requirementOrgPersonLoading}>
      <div className="realTrain" key={timestamp}>
        {this._personInfo(dataDetail)}
        {this._trainInfo(dataDetail)}
        {this._dpInfo(dataDetail)}
      </div>
    </WizSpin>
  }
}

const mapStateToProps = (state, ownProps) => {
  const { requirementOrgPerson } = state;
  const getInfo = modelUtils.getModelEntity(requirementOrgPerson, 'requirementOrgPerson@getInfo'+ownProps.record.id);
  const dpStateSet = modelUtils.getModelEntity(requirementOrgPerson, 'requirementOrgPerson@dpStateSet');
  const load = modelUtils.getLoadingState(state, "requirementOrgPerson");
  return {
    getInfo,
    dpStateSet,
    ...load,
  };
};

export default connect(mapStateToProps)(DpStateSet);

